import { render, staticRenderFns } from "./BatchAcompanhamento.vue?vue&type=template&id=17016d35"
import script from "./BatchAcompanhamento.vue?vue&type=script&lang=js"
export * from "./BatchAcompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports